import { assessmentNames } from "../lib/assessment";
import type { PresetRef } from "../contract/types";
import { Icon } from "../components/Icon";
import { PresetRenderer } from "../presets/PresetRenderer";
import type { BlockEventSink } from "../blocks/types";

/**
 * Vista de pantalla completa.
 *
 * Un preset **reemplaza** al stream, no flota encima: la affordance de vuelta
 * es una barra fija arriba, siempre en el mismo sitio, con el título de la
 * vista al lado. Nada de modales — el estudiante tiene que poder leer el plan
 * completo sin perder de vista dónde está ni cómo salir.
 */

export interface StageViewProps {
  preset: PresetRef;
  onClose: () => void;
  emit: BlockEventSink;
  interactive: boolean;
}

export function StageView({ preset, onClose, emit, interactive }: StageViewProps) {
  return (
    <div className="stage">
      <header className="stage__bar">
        <button type="button" className="u-button stage__back" onClick={onClose}>
          <Icon name="chevron-left" size="0.875rem" />
          Volver a la conversación
        </button>
        <span className="stage__title">{assessmentNames(preset.title ?? "Vista del curso")}</span>
      </header>

      <div className="stage__scroll">
        <div className="stage__inner">
          <PresetRenderer preset={preset} emit={emit} interactive={interactive} />
        </div>
      </div>
    </div>
  );
}

export default StageView;
